import type { AuditEntry } from '@root/@types/audit-log';
import type { User } from '@root/@types/types';

import { USER_DISPLAY_NAME_MAP } from '../constants';

const hasUserAttached = (user: User | undefined): user is User => {
  return user !== undefined;
};

export const mapAuditItemUser = (item: AuditEntry): AuditEntry => {
  if (!hasUserAttached(item.user)) {
    return item;
  }

  const isCustomUser = !!USER_DISPLAY_NAME_MAP[item.user.name];

  if (!isCustomUser) {
    return item;
  }

  return {
    ...item,
    user: { ...item.user, name: USER_DISPLAY_NAME_MAP[item.user.name] },
  };
};
